import * as S from "./style";
import { useForm, SubmitHandler } from "react-hook-form";
import { useNavigate, NavLink } from "react-router-dom";
/**
 * Components
 */
import logoMundial from "../../assets/logoMundial.svg";
import ActionButton from "../Button/ActionButtonLoad";
/**
 * hooks 
*/
import { usePasswordToggle } from "../../hooks/usePasswordToggle";
import useLoading from "../../hooks/useLoading";
import useErrorMessage from "../../hooks/useErroMessage";
/**
 * Icons
 */
import { Eye, EyeSlash } from "@phosphor-icons/react";
import axios from "axios";
import axiosInstance from "../../services/axiosInstance";
import { useAuth } from "../../context/AuthContext";

interface Inputs {
    email: string;
    password: string;
}
export default function FormLogin() {
    const navigate = useNavigate();

    const { inputType, icon, togglePasswordVisibility } = usePasswordToggle();
    const { isLoading, startLoading, stopLoading } = useLoading();
    const { errorMessage, showError, clearError } = useErrorMessage();

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<Inputs>();

    const { login } = useAuth()

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        startLoading();
        clearError(); // Limpar mensagens de erro ao iniciar a requisição

        try {
            const response = await axiosInstance.post('/login', data)
            login(response.data.token)
            navigate("/armacao");
        } catch (error: any) {
            if (axios.isAxiosError(error) && error.response) {
                const message = error.response.data?.message || error.response.data?.error || 'Erro desconhecido';
                console.error('Erro na requisição:', message);
                showError(message); // Definir a mensagem de erro no estado
            } else {
                const message = 'Ocorreu um erro inesperado. Tente novamente mais tarde.';
                console.error('Erro inesperado:', error);
                showError(message); // Definir mensagem padrão para erros inesperados
            }
        } finally {
            stopLoading(); // Desativar carregamento
        }
    };

    return (
        <S.Container>
            <S.Content>
                <S.Title>
                    <S.Image src={logoMundial} alt="Logo Mundial" />
                    <S.InforTitle>
                        <S.H3>Bem-vindo de volta!</S.H3>
                        <S.TextP>Para prosseguir, informe suas credenciais.</S.TextP>
                    </S.InforTitle>
                </S.Title>
                {errorMessage && (
                    <S.InforTitleErro>{errorMessage}</S.InforTitleErro>
                )}

                <S.Forms onSubmit={handleSubmit(onSubmit)}>
                    <S.InputForms>
                        <S.Label>E-mail *</S.Label>
                        <S.Input
                            {...register("email", { required: true })}
                            type="email"
                            placeholder="Informe seu e-mail"
                        />
                        {errors.email && <S.InforErro>Campo Obrigatório</S.InforErro>}
                    </S.InputForms>

                    <S.ContainerPassword>
                        <S.InputForms>
                            <S.Label>Senha *</S.Label>
                            <S.ContentInput>
                                <S.InputUnstyled
                                    {...register("password", { required: true })}
                                    type={inputType}
                                    placeholder="Informe sua senha"
                                />

                                <S.ButtonOpenPassword type="button" onClick={togglePasswordVisibility}>
                                    {icon === "eye-open" ? (
                                        <Eye size={20} />
                                    ) : (
                                        <EyeSlash size={20} />
                                    )}
                                </S.ButtonOpenPassword>
                            </S.ContentInput>
                            {errors.password && <S.InforErro>Campo Obrigatório</S.InforErro>}
                        </S.InputForms>

                        <S.ForgotPassword>
                            Esqueceu a senha?
                            <NavLink to='/recuperarsenha' style={{ textDecoration: 'none' }}>
                                <span>Clique aqui.</span>
                            </NavLink>
                        </S.ForgotPassword>
                    </S.ContainerPassword>
                    <ActionButton
                        type="submit"
                        name={isLoading ? 'Carregando...' : 'Login'}
                        status={isLoading}
                        onClick={handleSubmit(onSubmit)}
                    />
                </S.Forms>


            </S.Content>
        </S.Container>
    );
}
